import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './axios';
import * as filters from './utils';
import Element from 'element-ui';

console.log(`环境变量：${JSON.stringify(process.env)}`);

switch (process.env.NODE_ENV) {
    case 'production':
        Vue.config.productionTip = true;
        Vue.config.debug = false;
        break;
    case 'mock':
        require('./mock')
        break;
    default:
        Vue.config.productionTip = false;
        Vue.config.debug = false;
        break
}

// First, checks if it isn't implemented yet.
if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}

// register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.use(Element);
Vue.prototype.$axios = axios;

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    const user = store.state.user;
    // console.log('User:', user, 'To:', to.path);
    if (!user && to.path !== '/login') {
        next('/login');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
})

new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
});